// actions/test-maintenance/untouchables.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// -- ADD -- //
export function addHasErrored(bool) {
  return {
    type: 'U_ADD_TEST_M_HAS_ERRORED',
    hasErrored: bool
  };
}

export function addIsLoading(bool) {
  return {
    type: 'U_ADD_TEST_M_IS_LOADING',
    isLoading: bool
  };
}

export function addFetchDataSuccess(resp) {
  return {
    type: 'U_ADD_TEST_M_FETCH_DATA_SUCCESS',
    resp
  };
}

export function addFetchData(host, body, reset) {
  return (dispatch) => {
    if (reset) {
      dispatch(addFetchDataSuccess({}))
      dispatch(addIsLoading(false));
      dispatch(addHasErrored(false));
    }
    else {
      dispatch(addIsLoading(true));
      dispatch(addHasErrored(false));
      fetch(host + 'admin/untouchables/add', {
        method: 'post',
        body: JSON.stringify(body),
        headers: attachAuth()
      }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        dispatch(addIsLoading(false));
        promise.json()
          .then(result => {
            dispatch(addFetchDataSuccess(result))
            PubSub.publish('test.maintenance.add', result);
          })
          .catch((e) => {
            console.log(e);
            dispatch(addHasErrored(true))
          });
        })
        .catch((e) => {
          console.log(e);
            dispatch(addIsLoading(false));
            dispatch(addHasErrored(true))
        });
    }
  };
}

// -- UNTOUCHABLES -- //
export function untouchablesHasErrored(bool) {
  return {
    type: 'U_LIST_TEST_M_HAS_ERRORED',
    hasErrored: bool
  };
}

export function untouchablesIsLoading(bool) {
  return {
    type: 'U_LIST_TEST_M_IS_LOADING',
    isLoading: bool
  };
}

export function untouchablesFetchDataSuccess(resp) {
  return {
    type: 'U_LIST_TEST_M_FETCH_DATA_SUCCESS',
    resp
  };
}

export function untouchablesFetchData(host) {
  return (dispatch) => {
    dispatch(untouchablesIsLoading(true));
    dispatch(untouchablesHasErrored(false));
    fetch(host + 'user/untouchables', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
      
      dispatch(untouchablesIsLoading(false));
      promise.json()
        .then(result => {
          dispatch(untouchablesFetchDataSuccess(result))
        })
        .catch((e) => {
          console.log(e);
          dispatch(untouchablesHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
          dispatch(untouchablesIsLoading(false));
          dispatch(untouchablesHasErrored(true));
      });
  };
}